import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const Filter2Icon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 13.312V10.688H20V13.312H4ZM0 4H24V6.688H0V4ZM9.312 20V17.312H14.688V20H9.312Z'
                fill='currentColor'
            />
        </>
    ),
})

Filter2Icon.displayName = 'Filter2Icon'
